module.exports = __webpack_public_path__ + "img/04.29547063.jpg";